import { initMonitoring } from '@/lib/monitoring/init'
import { installStaleBundleHandler } from '@/lib/stale-bundle'
import { createRoot } from 'react-dom/client'
import './index.css'
import '../styles.css'
import './features/city-clerk/new-playground/styles/playground-index.css'
import '@/i18n/config'
import App from './App.tsx'
import { ThemeProvider } from '@/theme'
import { LanguageProvider } from '@/i18n'
import {
  setPlaygroundDataProvider,
  backendPlaygroundProvider,
} from '@/features/city-clerk/new-playground/data'

setPlaygroundDataProvider(backendPlaygroundProvider)

installStaleBundleHandler()

initMonitoring()

createRoot(document.getElementById('root')!).render(
  <ThemeProvider>
    <LanguageProvider>
      <App />
    </LanguageProvider>
  </ThemeProvider>,
)
